/** Адрес бустов для основного публичного канала из настроек админки. */
export function boostLinkFrom(channelUrl: string | null): string | null {
  if (!channelUrl) return null;
  try {
    const url = new URL(channelUrl);
    if (
      !['http:', 'https:'].includes(url.protocol) ||
      !['t.me', 'telegram.me'].includes(url.hostname)
    ) {
      return null;
    }
    const username = /^\/([A-Za-z0-9_]+)\/?$/.exec(url.pathname)?.[1];
    return username ? `https://t.me/boost/${username}` : null;
  } catch {
    return null;
  }
}
